import React, { useState } from 'react'
import { Image } from '../../../common/Image'
import { useModal } from '../../../../hooks/useModal'
import { MediaGalleryModal } from '../../../common/MediaGalleryModal'

interface ChatMessageImagesProps {
  media:
    | { _id: string; url?: string; thumbUrl?: string; createdAt?: string }[]
    | undefined
  messageAuthorIsCurrentUser: boolean
}

export const ChatMessageImages = ({
  media,
  messageAuthorIsCurrentUser,
}: ChatMessageImagesProps): JSX.Element => {
  const {
    show: showMediaGalleryModal,
    open: openMediaGalleryModal,
    close: closeMediaGalleryModal,
  } = useModal()
  const [mediaGalleryIndex, setMediaGalleryIndex] = useState<number>(0)
  const galleryMedia =
    media?.map((_media) => ({
      id: _media._id,
      url: _media.url,
      createdAt: _media.createdAt,
    })) ?? []

  const openModal = (i: number): void => {
    setMediaGalleryIndex(i)
    openMediaGalleryModal()
  }

  const getMediaWidth = (): string => {
    switch (media?.length) {
      case 1:
        return 'flex-1/1'
      case 2:
        return 'flex-1/2'
      default:
        return 'flex-1/3'
    }
  }

  return (
    <>
      {media && media.length > 0 && (
        <div
          className={`-mr-1 flex max-w-xl flex-col
          ${messageAuthorIsCurrentUser ? 'self-end' : ''}
        `}
        >
          <div className="flex w-full flex-wrap justify-end max-h-52">
            {media.map((_media, i) => (
              <div key={_media._id} className={getMediaWidth()}>
                <Image
                  url={_media.thumbUrl ?? _media.url}
                  imageClassName="rounded-2xl p-1 cursor-pointer max-h-52"
                  onClick={() => openModal(i)}
                />
              </div>
            ))}
            {showMediaGalleryModal && galleryMedia.length > 0 && (
              <MediaGalleryModal
                show={showMediaGalleryModal}
                close={closeMediaGalleryModal}
                media={galleryMedia}
                mediaGalleryIndex={mediaGalleryIndex}
                setMediaGalleryIndex={setMediaGalleryIndex}
              />
            )}
          </div>
        </div>
      )}
    </>
  )
}
